/**
 * Textarea field can have the following rules, which affect style and functionality (admin app):
 * - RequiredIf - set * after the label
 * - EnableIf - set both textarea field and label to disabled, when False
 * - ReadOnlyIf - set both textarea field and label to readOnly
 */

import { Component, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { selectMessagesForOpenedEditorForProperty } from 'src/app/project/store/project-data/project-data.selectors';
import { take } from 'rxjs';
import type { TreeEntity } from '../../../core/models/entity.model';
import { EntityPropertyBaseComponent } from '../entity-property-base/entity-property-base.component';
import type { Property } from '../../../core/models/property.model';

@Component({
  selector: 'app-entity-property-textbox',
  templateUrl: './entity-property-textbox.component.html',
  styleUrls: ['./entity-property-textbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class EntityPropertyTextboxComponent extends EntityPropertyBaseComponent<string> implements OnChanges {
  messages: TreeEntity[] = [];

  messagesForOpenedEditorForProperty$ = (key: string) => this.store.select(selectMessagesForOpenedEditorForProperty(key, this.entityId));

  constructor(private store: Store) {
    super();
    this.messagesForOpenedEditorForProperty$ = (propertyKey: string) =>
      this.store.select(selectMessagesForOpenedEditorForProperty(this.property.Key, this.entityId)).pipe(take(1));
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes['property']) {
      this.messagesForOpenedEditorForProperty$(this.property.Key)
        .pipe(take(1))
        .subscribe(msgs => (this.messages = msgs));
    }
  }

  showCounter(property: Property) {
    const setMaxLengthRule = property.Rules.SetMaxLength;
    return setMaxLengthRule !== undefined;
  }

  getMaxLength(property: Property) {
    return property.Rules.SetMaxLength;
  }

  getMinLength(propertyForm: UntypedFormControl) {
    return propertyForm.errors && propertyForm.errors['minlength'] && propertyForm.errors['minlength']['requiredLength'];
  }

  getCurrentLength(propertyForm: UntypedFormControl) {
    return (propertyForm.value && propertyForm.value.length) || 0;
  }
}
